<a id="mainLogo" class="main-logo fixed-top p-2 mx-auto mt-2" routerLink="/">
  <img src="assets/images/logo-text.svg" />
</a>
